(function($){

	$(document).ready(function(){

		$('.whats-new-content__slider').each(function(index){
	
			if(!$(this).hasClass('slick-initialized')) {

				$prevArrow = $(this).siblings('.whats-new-content__slider-navigation').find('.prev-arrow');
				$nextArrow = $(this).siblings('.whats-new-content__slider-navigation').find('.next-arrow');

				$(this).on('init afterChange', function(e, slick){

				  	currentSlick = $('.slick-current.slick-active', slick.$slideTrack);
				  	currentSlickIndex = String(currentSlick.index() + 1).padStart(2, '0');

				  	$(this).siblings('.whats-new-content__slider-navigation').find('.nav-labels .nav-current').text(currentSlickIndex);
				  	$(this).siblings('.whats-new-content__slider-navigation').find('.nav-labels .nav-total').text(String(slick.slideCount).padStart(2, '0'));
				  	
				}).on('init', function(e, slick){

					if(slick.slideCount <= 1) {
						$(this).siblings('.whats-new-content__slider-navigation').hide();
					}

				}).slick({
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        arrows: true,
			        dots: false,
			        infinite: false,
			        autoplay: false,
			        swipe: true,
			        variableWidth: true,
					prevArrow: $prevArrow,
					nextArrow: $nextArrow
			    });
			}
		});


		$(document).on('keydown', function(e) {
			if(e.keyCode == 27) {
				$('.whats-new-tabbed-content-module .panel-body__modal .panel-body__modal-close').trigger('click');
			}
		});

		$(document).on('click','.whats-new-tabbed-content-module .nav-tabs li a', function(e) {
			$('.whats-new-tabbed-content-module .panel-body__modal .panel-body__modal-close').trigger('click');
		});

		$(document).on('click','.whats-new-tabbed-content-module .panel-body__modal .panel-body__modal-close', function(e){
			e.preventDefault();
			$(this).parent('.panel-body__modal').fadeOut();
		});


		$(document).on('click','.whats-new-tabbed-content-module .whats-new-content__slider-item .modal-trigger', function(e){
			e.preventDefault();

			$modal_year = urldecode($(this).data('modalYear'));
			$modal_title = urldecode($(this).data('modalTitle'));
			$modal_image = urldecode($(this).data('modalImage'));
			$modal_content = urldecode($(this).data('modalContent'));

			$modal_html = '<div class="modal-content__grid-wrapper">' + 
				'<div class="modal-content__grid">' + 
				'<div class="modal-content__grid-left">' +
				'<div class="media-container">' +
				$modal_image +
				'<div class="media-overlay"></div>' +
				'<div class="content">' +
				'<span class="year">' + 
				$modal_year + 
				'</span>' +
				'<h2 class="title">' +
				$modal_title + 
				'</h2>' +
				'</div>' +
				'</div>' +
				'</div>' +
				'<div class="modal-content__grid-right">' +
				'<div class="content-scroller">' + 
				$modal_content +
				'</div>' +
				'</div>' +
				'</div>' +
				'</div>'; 

			$panel_body_modal = $(this).parents('.panel-body').find('.panel-body__modal');

			$panel_body_modal.find('.panel-body__modal-content').html($modal_html);
			$panel_body_modal.fadeIn();
		});
	});
	
})(jQuery);

function urldecode(str) {
	return decodeURIComponent((str + '').replace(/\+/g, '%20'));
}